import React, { PureComponent } from 'react';
import { LoadClassification } from '../../../../../model/CORE';
import { MonitoredLoadBar, MonitoredLoadBarProps } from './MonitoredLoadBar';
import MeasureUtils from '../../../../../common/util/MeasureUtils';

interface MeasureLoadBarProps extends Omit<MonitoredLoadBarProps, 'fillColor' | 'occupancyPeriods'> {
    fillColor?: string; // forces measure load bar to use this color instead of the fill color function
}

export class MeasureLoadBar extends PureComponent<MeasureLoadBarProps> {
    getFillColor = (loadClassification: LoadClassification): string => {
        if (this.props.fillColor && loadClassification !== LoadClassification.UNDEFINED) return this.props.fillColor;

        return MeasureUtils.getFillColor(loadClassification);
    };

    render() {
        return (
            <MonitoredLoadBar
                loadValues={this.props.loadValues}
                monitoredPeriod={this.props.monitoredPeriod}
                currentTime={this.props.currentTime}
                barHeightEm={this.props.barHeightEm}
                fillColor={this.getFillColor}
                hideLabel={this.props.hideLabel}
            />
        );
    }
}
